export function fieldRequired (message = 'This field is required') {
    return (value) => (!!value || value === 0) || message;
}

export function selectionRequired (message = "Selection required." ) {
    return (value) => (value.length > 0) || message;
}

export function maxLength (length, fieldName = "Field") {
    return (value) => (value.length <= length) || `${fieldName} must be less than ${length} characters`;
}

export function minValue (minimum, fieldName = "Field") {
    return (value) => (value != '$0.00') || `${fieldName} amount must be greater than ${length}.`;
}

export function validEmail (message = 'E-mail must be valid') {
    return (v) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || message
}

export function readTerms (tosRead) {
    console.log(tosRead)
    return () => tosRead || "asdasd"
}